import { render, staticRenderFns } from "./PromoActionCreate.vue?vue&type=template&id=5ba22ebe&"
import script from "./PromoActionCreate.vue?vue&type=script&lang=js&"
export * from "./PromoActionCreate.vue?vue&type=script&lang=js&"
import style0 from "./PromoActionCreate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports